import styled from 'styled-components';
import { PaginationFooter } from 'ui/paginationFooter';
import { colors, spacing } from 'ui/theme';
import { NestedTableView } from 'ui/treeView/NestedTableView';
import { useSnippetsContext } from '../context';
import { useGetLoadingTableData } from '../hooks';
import { CA_STORAGE_KEY, MI_STORAGE_KEY } from './constants';
import { HeaderRow } from './HeaderRow';
import { EmptyState, ErrorState, NoSearchResultsState } from './alternativeStates';
import { TableHeader } from './TableHeader';
import { SnippetsTableModes } from '../types';

export const PAGINATION_FOOTER_TEST_ID = 'pagination-footer';

const StyledPaginationFooter = styled(PaginationFooter)`
  padding-bottom: ${spacing.base};
`;

const StyledTableWrapper = styled.div`
  overflow: auto;
`;

export const SnippetsTable = ({ showCampaignToggle }: { showCampaignToggle?: boolean }) => {
  const {
    tableData,
    mode,
    pagination: { page, limit, count },
    searchTerm,
    hasError,
    isLoading,
    handlePageChange,
  } = useSnippetsContext();

  const src = tableData || [];
  const loadingSrc = useGetLoadingTableData();

  const storageKey =
    mode === SnippetsTableModes.CampaignAnalytics ? CA_STORAGE_KEY : MI_STORAGE_KEY;

  const AlternativeStates = () => {
    if (isLoading) {
      return <NestedTableView src={loadingSrc} />;
    }

    if (hasError) {
      return <ErrorState />;
    }

    return searchTerm ? <NoSearchResultsState /> : <EmptyState />;
  };

  return (
    <>
      <TableHeader showCampaignToggle={showCampaignToggle} />
      <StyledTableWrapper>
        <HeaderRow />
        {src.length > 0 ? (
          <NestedTableView
            storageKey={storageKey}
            src={src}
            tableColor={colors.backgroundSecondary}
            altRowColorDepth={1}
            showBranchFocus
          />
        ) : (
          <AlternativeStates />
        )}
      </StyledTableWrapper>
      <StyledPaginationFooter
        data-test={PAGINATION_FOOTER_TEST_ID}
        currentPage={page}
        itemsPerPage={limit}
        numItems={count}
        onUpdate={handlePageChange}
      />
    </>
  );
};
